import './src/vaadin-button.js';

export * from './src/vaadin-button.js';
